export const componentStyles = new String(".logos-title-component.jsx-aa1747c6318d2e78{padding:0 32px;text-align:center}");
componentStyles.__hash = "aa1747c6318d2e78";
